import { Box } from "@chakra-ui/react";
import { motion, useScroll, useSpring } from "framer-motion";

const MotionBox = motion(Box);

export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 240,
    damping: 40,
    mass: 0.2,
  });

  return (
    <MotionBox
      position="fixed"
      top={0}
      left={0}
      right={0}
      height="3px"
      transformOrigin="0%"
      bgGradient="linear(to-r, accent.500, accent.300)"
      zIndex={100}
      style={{ scaleX }}
      aria-hidden
    />
  );
}
